import { render } from "./FreezeAndPopUp.vue?vue&type=template&id=406f09e6"
import script from "./FreezeAndPopUp.vue?vue&type=script&lang=js"
export * from "./FreezeAndPopUp.vue?vue&type=script&lang=js"

import "./FreezeAndPopUp.vue?vue&type=style&index=0&id=406f09e6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__